module.exports = __webpack_public_path__ + "img/IBEDC.7ccfe96c.svg";